import { storageObjectAdapter } from "../adapter";
import type { ServiceState, StorageObjectState } from "../types";

export function makeInitialState(): ServiceState {
  return {
    data: storageObjectAdapter.getInitialState(),
    selectedId: null,
    versions: null,
    selectedVersionId: null,
    hasMutation: true,
    loading: false,
    error: null,
  };
}

export function generateStorageInitialState(
  servicesArray: (keyof StorageObjectState)[],
): StorageObjectState {
  return servicesArray.reduce((acc, service) => {
    return {
      ...acc,
      [service]: makeInitialState(),
      sharedObjects: [],
      currentService: null,
    };
  }, {} as StorageObjectState);
}
